import { IonButton, IonText } from '@ionic/react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { t } from 'ttag';

import { UserSession, VerifyType } from '@custom-types/UserSession';
import Layout from '@pages/Auth/Layout';
import { Locale } from '@services/language-service';
import { getLocale } from '@state/system';
import { Browser } from '~capacitor-plugins/browser';

import EmailForm from './EmailForm';
import EmailLinkSuccess from './EmailLinkSuccess';
import PasswordForm from './PasswordForm';

const LoginSupport = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;

enum LoginSupportLinks {
  En = 'https://help.eventmobi.com/en/knowledge/lead-capture-app-login-support',
  De = 'https://help.eventmobi.com/de/knowledge/unterstutzung-der-lead-capture-app',
}

const isCurrentStageEmail = (user?: UserSession) => !user;
const isCurrentStagePassword = (user: UserSession, isEmailLinkSent: boolean) =>
  user?.result === VerifyType.Password && !isEmailLinkSent;
const isCurrentStageEmailSuccess = (user: UserSession, isEmailLinkSent: boolean) =>
  user?.result === VerifyType.OneTimeCode || isEmailLinkSent;

const Login = () => {
  const locale = useSelector(getLocale);
  const [verifiedUser, setVerifiedUser] = useState<UserSession>();
  const [isEmailLinkSent, setIsEmailLinkSent] = useState(false);

  const resetVerifiedUser = () => {
    setVerifiedUser(undefined);
    setIsEmailLinkSent(false);
  };

  const loginSupportLink = locale === Locale.De ? LoginSupportLinks.De : LoginSupportLinks.En;

  return (
    <Layout hideLogo showLanguage={isCurrentStageEmail(verifiedUser)}>
      <>
        {isCurrentStageEmail(verifiedUser) && (
          // skipcq: JS-0417, JS-0336
          <EmailForm onSuccess={user => setVerifiedUser(user)} />
        )}
        {verifiedUser && isCurrentStagePassword(verifiedUser, isEmailLinkSent) && (
          <PasswordForm
            // skipcq: JS-0417, JS-0336
            resetVerifiedUser={resetVerifiedUser}
            user={verifiedUser}
            setIsEmailLinkSent={setIsEmailLinkSent}
          />
        )}
        {verifiedUser && isCurrentStageEmailSuccess(verifiedUser, isEmailLinkSent) && (
          // skipcq: JS-0417, JS-0336
          <EmailLinkSuccess user={verifiedUser} goBack={resetVerifiedUser} />
        )}

        <LoginSupport>
          <IonText>{t`Need Help?`}</IonText>
          <IonButton
            fill="clear"
            className="ion-text-capitalize"
            // skipcq: JS-0417, JS-0336
            onClick={() => Browser.open({ url: loginSupportLink })}
          >
            {t`Login Support`}
          </IonButton>
        </LoginSupport>
      </>
    </Layout>
  );
};

export default Login;
